import { useQuery, useMutation, useQueryClient, keepPreviousData } from '@tanstack/react-query';
import {
  HSNCodeService,
  CreateHSNCodeDto,
  UpdateHSNCodeDto,
  HSNCodeQueryParams,
} from '../services/hsncode.service';

export const useHSNCodesPage = (params: HSNCodeQueryParams) => {
  return useQuery({
    queryKey: ['hsnCodes', 'page', params],
    queryFn: () => HSNCodeService.getHSNCodesPage(params),
    placeholderData: keepPreviousData,
  });
};

export const useHSNCodeSummary = () => {
  return useQuery({
    queryKey: ['hsnCodes', 'summary'],
    queryFn: () => HSNCodeService.getHSNCodeSummary(),
  });
};

const useInvalidateHSNCodes = () => {
  const queryClient = useQueryClient();
  return () => {
    queryClient.invalidateQueries({ queryKey: ['hsnCodes'] });
    // The list the invoice form offers
    queryClient.invalidateQueries({ queryKey: ['hsn-codes'] });
  };
};

export const useCreateHSNCode = () => {
  const invalidate = useInvalidateHSNCodes();
  return useMutation({
    mutationFn: (data: CreateHSNCodeDto) => HSNCodeService.createHSNCode(data),
    onSuccess: invalidate,
  });
};

export const useUpdateHSNCode = () => {
  const invalidate = useInvalidateHSNCodes();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateHSNCodeDto }) => HSNCodeService.updateHSNCode(id, data),
    onSuccess: invalidate,
  });
};

export const useDeleteHSNCode = () => {
  const invalidate = useInvalidateHSNCodes();
  return useMutation({
    mutationFn: (id: string) => HSNCodeService.deleteHSNCode(id),
    onSuccess: invalidate,
  });
};
